import { useState } from 'react';

import { UserType } from '@gearbelt/global';

import GearbeltSquare from '@/assets/gearbelt-square.svg';
import SitemateSquare from '@/assets/sitemate-square.svg';
import { ButtonStateToggle } from '@/components/ui/button-state-toggle';

import ContributorsPage from './contributors';
import SitemateUsersPage from './sitemate-users';

function UsersPage() {
  const [selectedUserType, setSelectedUserType] = useState<UserType>(UserType.GearbeltContributors);

  return (
    <div className="flex h-fit w-full flex-col">
      <div className="sticky top-0 z-20">
        <div className="border-grey-3 bg-grey-2 flex items-center gap-x-2 border-b-[1px] px-2 py-1">
          <div className="text-sm font-medium">User Types</div>
          <ButtonStateToggle
            options={[
              {
                icon: <img src={GearbeltSquare} alt="Gearbelt Contributors" className="h-[20px] w-[20px]" />,
                label: 'Gearbelt Contributors',
                value: UserType.GearbeltContributors,
              },
              { icon: <img src={SitemateSquare} alt="Sitemate Users" className="h-[20px] w-[20px]" />, label: 'Sitemate Users', value: UserType.SitemateUsers },
            ]}
            value={selectedUserType}
            onChange={setSelectedUserType}
          />
        </div>
      </div>
      {selectedUserType === UserType.GearbeltContributors && <ContributorsPage />}
      {selectedUserType === UserType.SitemateUsers && <SitemateUsersPage />}
    </div>
  );
}

export default UsersPage;
